const removeAttributes = (element: Element) => {
  for (let i = 0; i < element.attributes.length; i++) {
    if(element.attributes[i].name === 'href') continue

    element.removeAttribute(element.attributes[i].name);
  }
}

export default removeAttributes
